<template>
  <span>
    <b>{{ field.name || condition.field }}</b>
  </span>
</template>
<script>

export default {
  name: 'HasSignature',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
